
  import {Component, Vue} from "vue-property-decorator";
  import TopControls from "@/modules/barriers/components/TopControls.vue";
  import {httpResource} from "@/resources/http.resource";
  import {Barrier} from "@/modules/barriers/interfaces/barrier.interface";
  import BarriersList from "@/modules/barriers/components/BarriersList.vue";
  import {IApp} from "@/interfaces/app.interface";
  import moment from "moment";
  import {ANONYMOUS_PAGE} from "@/modules/Auth/stores/auth.store";
  import AppPageHeader from "@/components/AppPageHeader.vue";
  import ClaimsPopup from "@/modules/barriers/components/ClaimsPopup.vue";
  import {IDialogStoreState} from "@/modules/Popup/interfaces/dialog.interface";
  import {bus} from "@/plugins/bus";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
  import DemoMovesPopup from "@/modules/barriers/components/DemoMovesPopup.vue";
  import AlertNotice from "@/modules/barriers/components/AlertNotice.vue";
  import OpenBarrierPopup from "@/modules/barriers/components/OpenBarrierPopup.vue";
  import BarrierLogPopup from "@/modules/barriers/components/EventsLog/BarrierLogPopup.vue";
  import TrailerPopup from "@/modules/barriers/components/TrailerPopup.vue";
  import SimilarNumbersPopup from "@/modules/barriers/components/SimilarNumbers/SimilarNumbersPopup.vue";

  @Component({
    components: {
      SimilarNumbersPopup,
      TrailerPopup,
      BarrierLogPopup,
      TopControls,
      BarriersList,
      AppPageHeader,
      ClaimsPopup,
      DemoMovesPopup,
      AlertNotice,
      OpenBarrierPopup,
    },
  })
  export default class PageBarriers extends Vue {
    $refs: any;
    isLoading: boolean = true;
    barriersList: Barrier.Entity[] = [];
    routes = IApp.ROUTE_NAME;
    parkId = null;
    intervalGetBarrier = null;
    timeResponse = null;
    enterByQR = false;
    parkInfo = '';
    infoAutoRefresFlag = true;
    sortingSwitched = true;
    dataLoaded = false;
    userInfo = {
      email: '',
      phone: '',
    };

    get dialogs(): IDialogStoreState { return this.$store.state.dialog; }
    get userAccess(): IAuth.UserAccess { return this.$store.state.auth.userAccess; }
    get anonymous() { return this.$store.state.route.query[ANONYMOUS_PAGE] ? JSON.parse(this.$store.state.route.query[ANONYMOUS_PAGE]) : false; }
    get timeResponseString() {
      let time = this.timeResponse ? this.timeResponse.format('HH:mm:ss') : '';
      return time;
    }
    get sortedList(): Barrier.Entity[] {
      // let list = this.barriersList;
      // if (this.sortingSwitched) {
      //   list.sort((a, b) => a.camId > b.camId ? 1 : -1)
      // }
      // return list;
      return this.barriersList;
    }
    get autoRefreshAvailable() { return this.userAccess && this.userAccess.scAutoRefreshGates; }

    async created() {
      const urlParkId = this.$store.state.route.query['parkId'];
      this.enterByQR = this.anonymous && Boolean(urlParkId || urlParkId === 0);
      // this.sortingSwitched = Boolean(JSON.parse(localStorage.getItem(Barrier.LocalStorageKeys.SortedCams)));

      try {
        await this.$store.dispatch('auth/init');
        await this.$store.dispatch('book/initBooksForPage', this.$route.name);
        await this.$store.dispatch('initialized');

        if (this.enterByQR) {
          localStorage.setItem(Barrier.LocalStorageKeys.SelectedPark, urlParkId.toString());
        }
        this.isLoading = false;
      }
      catch (error) { await this.$store.dispatch('handleError', error, { root: true }); }
    }

    mounted() {
      bus.$on(Barrier.BusEvents.StopLoadingBarriers, () => {
        clearInterval(this.intervalGetBarrier);
        this.intervalGetBarrier = null;
      });
      bus.$on(Barrier.BusEvents.RestartLoadBarriers, () => {
        this.startLoop(this.parkId);
      });
    }

    startLoop(parkId) {
      this.infoAutoRefresFlag = true;
      let parkChanged = this.parkId !== parkId;
      this.parkId = parkId;
      this.getBarriersList(parkChanged);
      clearInterval(this.intervalGetBarrier);
      this.intervalGetBarrier = null;
      this.intervalGetBarrier = setInterval(this.getBarriersList, 3000);

      if(!this.autoRefreshAvailable) {
        setTimeout(() => {
          this.infoAutoRefresFlag = false;
          clearInterval(this.intervalGetBarrier);
        }, 60000);
      }
    }

    async getBarriersList(parkChanged = false) {
      let asyncAction = async () => {
        const params: any = { parkId: this.parkId ? this.parkId : -219811, };
        const { data: { result: response } } = await httpResource.httpAction({action: Barrier.Action.GateInfo, params});
        this.barriersList = response.GateInfo;
        this.parkInfo = response.ParkInfo;
        this.userInfo = response.userInfo;
        this.timeResponse = moment();

        if (this.$refs.barriersList) {
          this.$refs.barriersList.updateAllCarNumbers();
          if (parkChanged) {
            await this.$nextTick();
            this.$refs.barriersList.setCustomListOrder();
          }
        }
      };

      try {
        await asyncAction();
        this.dataLoaded = true;
      }
      catch (error) {
        if (this.dataLoaded) {
          this.$notify({
            title: 'Потеря связи',
            message: '',
            type: 'error'
          });
          clearInterval(this.intervalGetBarrier);
          this.infoAutoRefresFlag = false;
        }
        else {
          await this.$store.dispatch('handleError', error);
        }
      }
    }

    updateList() {
      // this.sortingSwitched = !this.sortingSwitched;
      // localStorage.setItem(Barrier.LocalStorageKeys.SortedCams, this.sortingSwitched.toString());
      this.startLoop(this.parkId);
    }

    destroyed() {
      clearInterval(this.intervalGetBarrier);
      bus.$off(Barrier.BusEvents.RestartLoadBarriers);
      bus.$off(Barrier.BusEvents.StopLoadingBarriers);
    }
  }
